/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeViewCtrl
 */
angular.module('mercury.modules.stock.stocktake')
.controller('StockStocktakeViewCtrl', ["$scope", "$state", "$stateParams", "Stocktakes", "title", "StockCost", function($scope, $state, $stateParams, Stocktakes, title, StockCost) {
  title.set('View Stocktake');

  //Fetch the stocktake data
  $scope.stocktake = Stocktakes.getStockApi($stateParams.id);
  $scope.stocktakeId = $stateParams.id;

  $scope.stocktake.then(function(stocktake) {
    $scope.stocktake = stocktake;
    
    $scope.groups = [];
    $scope.stocktakeTotalCost = 0;
    angular.forEach($scope.stocktake.lines, function(line) {
      if (!line.itemId) {
        $scope.groups.push({
          name: line.name,
          totalCost: 0,
          lines: []
        });
      } else {
        $scope.groups[$scope.groups.length - 1].lines.push(line);
      }
    });

    $scope.stockCostPromise = StockCost.getFromStocktake(stocktake.id)
      .then(function(costs) {
        
        $scope.groups.forEach(function(group, idx) {
          group.lines.forEach(function(line) {
            // We know there will only be one item in the array as we only use completedAt as the cost time
            var itemStockCost = costs.itemCosts[line.itemId][0].cost;
            line.itemStockCost = itemStockCost;
  
  
            var lineCost = itemStockCost * line.quantity;
  
            $scope.stocktakeTotalCost += lineCost;
            $scope.groups[idx].totalCost += lineCost;
          })
        }
      )
    });
  }, function() {
    $state.go('Stock.Stocktakes');
  });

  /**
   * Checks whether a promise is pending
   * @param {*} promise the promise to check
   * @returns true if the promise is pending false if not
   */
    $scope.promiseIsPending = function(promise) {
      return promise && promise.$$state.status == 0;
    };

  $scope.viewStockCost = function(line) {
    $state.go('.StockPrice',
    {itemId: line.itemId, quantity: line.quantity, unitRatio: line.unitRatio, unitName: line.unitName, dateFor: $scope.stocktake.completedAt},
    {location: 'replace'});
  };
}]);
